<template>
    <v-container fluid>
        <!-- KPI -->
        <v-row class="mb-2">
            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Mezzi</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.totaleMezzi ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Totali censiti</div>
                            </div>
                            <v-avatar color="blue-lighten-4" size="44">
                                <v-icon color="primary">mdi-truck</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Attivi</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.mezziAttivi ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">In servizio</div>
                            </div>
                            <v-avatar color="green-lighten-4" size="44">
                                <v-icon color="success">mdi-check-circle</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">In manutenzione</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.mezziInManutenzione ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Attualmente fermi</div>
                            </div>
                            <v-avatar color="orange-lighten-4" size="44">
                                <v-icon color="orange-darken-2">mdi-wrench</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="6" md="3">
                <v-card variant="outlined" class="rounded-lg" height="100%">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div>
                                <div class="text-caption text-medium-emphasis">Scadenze scadute</div>
                                <div class="text-h4 font-weight-bold">{{ kpi.scadenzeScadute ?? '—' }}</div>
                                <div class="text-caption text-medium-emphasis">Richiedono attenzione</div>
                            </div>
                            <v-avatar color="red-lighten-4" size="44">
                                <v-icon color="error">mdi-calendar-alert</v-icon>
                            </v-avatar>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- Filtri -->
        <v-row class="align-center mb-2">
            <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="ricerca" label="Cerca mezzo" prepend-inner-icon="mdi-magnify"
                    density="compact" variant="outlined" hide-details clearable />
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <v-select v-model="stato" :items="statiDisponibili" item-title="label" item-value="value"
                    label="Tutti gli stati" density="compact" variant="outlined" hide-details clearable
                    @update:modelValue="carica" />
            </v-col>
        </v-row>

        <v-row class="align-center mb-2">
            <v-col cols="12" sm="auto" class="mr-auto">
                <span class="text-body-2 text-medium-emphasis">
                    {{ mezzi.length }} mezz{{ mezzi.length === 1 ? 'o trovato' : 'i trovati' }}
                </span>
            </v-col>
            <v-col cols="auto">
                <v-btn-toggle v-model="vista" mandatory color="primary" density="comfortable" class="rounded-lg"
                    @update:modelValue="salvaVista">
                    <v-btn value="griglia" variant="text" icon="mdi-view-grid" />
                    <v-btn value="elenco" variant="text" icon="mdi-view-list" />
                </v-btn-toggle>
            </v-col>
            <v-col cols="12" sm="auto" v-if="isAdmin">
                <v-btn variant="outlined" prepend-icon="mdi-cog-outline" to="/tipi-scadenza-mezzo">
                    Tipi scadenza
                </v-btn>
            </v-col>
            <v-col cols="12" sm="auto" v-if="puoScrivere">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">
                    Nuovo mezzo
                </v-btn>
            </v-col>
        </v-row>

        <!-- Vista griglia -->
        <v-row v-if="vista === 'griglia'">
            <v-col v-for="m in mezzi" :key="m.id" cols="12" sm="6" md="4" lg="3">
                <v-card variant="outlined" class="rounded-lg mezzo-card" @click="vaiDettaglio(m.id)">
                    <v-card-text>
                        <div class="d-flex align-center justify-space-between">
                            <div class="font-weight-bold text-body-1">{{ m.nome }}</div>
                            <v-chip size="small" :color="coloreStato(m.stato)" variant="flat">
                                {{ etichettaStato(m.stato) }}
                            </v-chip>
                        </div>
                        <div class="text-caption text-medium-emphasis">{{ m.codice || '—' }}</div>
                        <div class="text-caption mt-2">{{ m.categoria }}<template v-if="m.targa">
                                · {{ m.targa }}</template></div>
                        <div class="text-caption mt-2">
                            <div><span class="text-medium-emphasis">Ultima scadenza:</span>
                                {{ formatData(m.ultimaScadenzaData) }}</div>
                            <div><span class="text-medium-emphasis">Prossima scadenza:</span>
                                {{ formatData(m.prossimaScadenzaData) }}</div>
                        </div>
                    </v-card-text>
                    <v-card-actions v-if="puoScrivere">
                        <v-spacer />
                        <v-btn icon variant="text" size="small" title="Duplica" @click.stop="duplica(m)">
                            <v-icon>mdi-content-copy</v-icon>
                        </v-btn>
                        <v-btn icon variant="text" size="small" @click.stop="apriDialog(m)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon variant="text" size="small" color="error" @click.stop="chiediEliminazione(m)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" v-if="mezzi.length === 0">
                <div class="text-center text-medium-emphasis pa-8">Nessun mezzo trovato con questi filtri.</div>
            </v-col>
        </v-row>

        <!-- Vista elenco -->
        <v-data-table v-else :headers="headers" :items="mezzi" :items-per-page="15" density="comfortable">
            <template #[`item.nome`]="{ item }">
                <a href="#" class="text-primary" @click.prevent="vaiDettaglio(item.id)">{{ item.nome }}</a>
            </template>

            <template #[`item.stato`]="{ item }">
                <v-chip size="small" :color="coloreStato(item.stato)" variant="flat">
                    {{ etichettaStato(item.stato) }}
                </v-chip>
            </template>

            <template #[`item.ultimaScadenzaData`]="{ item }">
                {{ formatData(item.ultimaScadenzaData) }}
            </template>

            <template #[`item.prossimaScadenzaData`]="{ item }">
                {{ formatData(item.prossimaScadenzaData) }}
            </template>

            <template #[`item.scadenzeScadute`]="{ item }">
                <v-chip v-if="item.scadenzeScadute > 0" size="small" color="error" variant="flat">
                    {{ item.scadenzeScadute }} scadute
                </v-chip>
                <span v-else class="text-medium-emphasis">—</span>
            </template>

            <template #[`item.azioni`]="{ item }" v-if="puoScrivere">
                <v-btn icon variant="text" size="small" title="Duplica" @click="duplica(item)">
                    <v-icon>mdi-content-copy</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="apriDialog(item)">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" color="error" @click="chiediEliminazione(item)">
                    <v-icon>mdi-delete</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <!-- Dialog creazione/modifica -->
        <dialog-mezzo v-model="dialog" :mezzo="mezzoSelezionato" @salvato="onSalvato" />

        <!-- Dialog conferma eliminazione -->
        <v-dialog v-model="dialogElimina" max-width="420">
            <v-card>
                <v-card-title>Confermi l'eliminazione?</v-card-title>
                <v-card-text>
                    Il mezzo "{{ mezzoDaEliminare?.nome }}" verrà rimosso (spostato nello storico).
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogElimina = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaEliminazione">Elimina</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog di conflitto: il mezzo ha scadenze collegate, mostrate prima di
             chiedere la conferma definitiva dell'eliminazione a cascata. -->
        <v-dialog v-model="dialogConflitto" max-width="480">
            <v-card>
                <v-card-title>Il mezzo ha scadenze collegate</v-card-title>
                <v-card-text>
                    <div class="mb-2">{{ conflittoMessaggio }}</div>
                    <v-list density="compact">
                        <v-list-item v-for="el in conflittoElementi" :key="el.id"
                            :title="formatData(el.data)" :subtitle="el.stato" />
                    </v-list>
                    <div class="mt-2 text-error">Procedendo verranno eliminate anche tutte queste scadenze.</div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialogConflitto = false">Annulla</v-btn>
                    <v-btn color="error" @click="eliminaComunque">Elimina comunque</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import DialogMezzo from "@/components/mezzi/DialogMezzo.vue";
import { STATI_MEZZO, coloreStato, etichettaStato } from "@/constants/statoMezzo.js";

export default {
    name: "MezziPage",

    components: {
        DialogMezzo,
    },

    data() {
        return {
            ricerca: "",
            stato: null,
            vista: localStorage.getItem("mezzi.vista") || "griglia",
            dialog: false,
            mezzoSelezionato: null,
            dialogElimina: false,
            mezzoDaEliminare: null,
            dialogConflitto: false,
            conflittoMessaggio: "",
            conflittoElementi: [],
            debounce: null,
            statiDisponibili: STATI_MEZZO,
            headers: [
                { title: "Nome", key: "nome" },
                { title: "Codice", key: "codice" },
                { title: "Targa", key: "targa" },
                { title: "Categoria", key: "categoria" },
                { title: "Stato", key: "stato" },
                { title: "Ultima scadenza", key: "ultimaScadenzaData" },
                { title: "Prossima scadenza", key: "prossimaScadenzaData" },
                { title: "Scadenze", key: "scadenzeScadute" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        mezzi() {
            return this.$store.getters["mezzi/lista"];
        },
        kpi() {
            return this.$store.getters["mezzi/kpi"] || {};
        },
        ruolo() {
            return this.$store.getters["user/getRole"];
        },
        puoScrivere() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin" || this.ruolo === "Operatore";
        },
        isAdmin() {
            return this.ruolo === "SuperAdmin" || this.ruolo === "Admin";
        },
    },

    watch: {
        ricerca() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => this.carica(), 300);
        },
    },

    mounted() {
        this.$store.dispatch("mezzi/caricaKpi");
        this.carica();
    },

    methods: {
        async carica() {
            try {
                await this.$store.dispatch("mezzi/carica", {
                    search: this.ricerca || undefined,
                    stato: this.stato || undefined,
                });
            } catch (error) {
                console.log(error);
            }
        },

        salvaVista(v) {
            localStorage.setItem("mezzi.vista", v);
        },

        vaiDettaglio(id) {
            this.$router.push({ path: `/mezzi/${id}` });
        },

        apriDialog(item) {
            this.mezzoSelezionato = item;
            this.dialog = true;
        },

        onSalvato() {
            this.carica();
            this.$store.dispatch("mezzi/caricaKpi");
        },

        async duplica(item) {
            try {
                await this.$store.dispatch("mezzi/duplica", item.id);
                this.carica();
                this.$store.dispatch("mezzi/caricaKpi");
            } catch (error) {
                console.log(error);
            }
        },

        chiediEliminazione(item) {
            this.mezzoDaEliminare = item;
            this.dialogElimina = true;
        },

        async confermaEliminazione() {
            try {
                await this.$store.dispatch("mezzi/elimina", { id: this.mezzoDaEliminare.id });
                this.carica();
                this.$store.dispatch("mezzi/caricaKpi");
                this.dialogElimina = false;
            } catch (error) {
                if (error.response && error.response.status === 409) {
                    this.conflittoMessaggio = error.response.data.message;
                    this.conflittoElementi = error.response.data.elementi || [];
                    this.dialogElimina = false;
                    this.dialogConflitto = true;
                } else {
                    console.log(error);
                    this.dialogElimina = false;
                }
            }
        },

        async eliminaComunque() {
            try {
                await this.$store.dispatch("mezzi/elimina", { id: this.mezzoDaEliminare.id, conferma: true });
                this.carica();
                this.$store.dispatch("mezzi/caricaKpi");
            } catch (error) {
                console.log(error);
            }
            this.dialogConflitto = false;
        },

        coloreStato,
        etichettaStato,

        formatData(data) {
            return data ? new Date(data).toLocaleDateString("it-IT") : "—";
        },
    },
};
</script>

<style scoped>
.mezzo-card {
    cursor: pointer;
    transition: border-color 0.15s, background-color 0.15s;
}

.mezzo-card:hover {
    border-color: rgb(var(--v-theme-primary));
}
</style>
